import styled from 'styled-components/macro'

export const StyledLogo = styled.div<{ isFadeIn }>`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 3;
  display: flex;
  align-items: center;
  cursor: default;
  opacity: ${(props) => (props.isFadeIn ? 1 : 0)};
  transition: opacity 0.5s;
`
